module.exports = __webpack_public_path__ + "static/media/balloon-v3@2x.d832890e.png";